import React, {useState, useMemo, useEffect, useContext, Fragment, useRef} from "react";
import { AgGridReact } from "@ag-grid-community/react"
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import 'ag-grid-community/styles/ag-theme-quartz.css';
import styles from './css/Results.module.css';
import {useNavigate} from "react-router-dom";
import '@mantine/core/styles.css';
import {useDisclosure} from "@mantine/hooks";
import {
    Button,
    TextInput,
    Flex,
    Text,
    Space,
    Select,
    Switch,
    Collapse,
    Accordion,
    List,
    Modal, Paper, Burger, AppShell, Menu, UnstyledButton, Drawer, Alert, Card, LoadingOverlay, Box
} from '@mantine/core'
import {IconBallpenOff, IconBallpen} from "@tabler/icons-react"
import { useForm } from '@mantine/form'
import { LoginContext } from "./Login";
import TopNavbar from "./components/TopNavbar";
import classes from './css/Results.module.css'
import { IconSearch, IconDashboard, IconFlagFilled, IconAntennaBars5, IconAntennaBars3, IconInfoCircle, IconRefresh, IconChevronDown, IconCircleNumber1} from '@tabler/icons-react'
import BreadcrumbsBar from "./components/BreadcrumbsBar";
import {setCustomer, setLoading, setExportLoading, setHighlighted} from "./redux/actions";
import { useSelector, useDispatch } from 'react-redux';
import ExportDrawer from "./components/ExportDrawer";
import MobileResults from "./MobileResults";
import { useTranslation } from 'react-i18next';
import GridHighlightButton from "./components/GridHighlightButton";

ModuleRegistry.registerModules([ ClientSideRowModelModule ]);

export default function Results() {

    const navigate = useNavigate()
    const [endpoints, setEndpoints] = useState([])
    const [rowData, setRowData] = useState(endpoints);
    const { logout , formatToBeaconDate, fetchEndpoints, lastActivationDate, lastSerialNumber,  setLastActivationDate, setLastSerialNumber } = useContext(LoginContext)
    const customerObject = JSON.parse(localStorage.getItem("customers"))
    const [customers,setCustomers] = useState(Object.keys(customerObject))
    const [loading, setLoadingRefresh] = useState(false)
    let interval = null
    const [isMobile, setMobile] = useState(window.innerWidth < 768);
    const [openedExportDrawer, { open: openDrawer, close: closeDrawer }] = useDisclosure(false);
    const [pageRefresh, setPageRefresh] = useState(null)

    const currentCustomer = useSelector(state => state.customer.currentCustomer);

    const [isMultiCustomer, setIsMultiCustomer] = useState(customers.length>1)

    const isLoading = useSelector(state => state.loading.isLoading);
    const { t } = useTranslation();
    const updateMedia = () => {
        setMobile(window.innerWidth < 768);
    };

    useEffect(() => {
        window.addEventListener("resize", updateMedia);
        return () => window.removeEventListener("resize", updateMedia);
    },[]);

    function toggleRefresh() {
        setLoadingRefresh(!loading);
    }

    function refreshPage() {
        window.location.reload()
        setPageRefresh(null)
    }

    useEffect(() => {
        if (loading === true) {
            interval = setInterval( () => {
                fetchEndpoints(customerObject[currentCustomer], setEndpoints, currentCustomer, lastSerialNumber, lastActivationDate)
            }, 5000, [interval]); //set your time here. repeat every 5 seconds
        }
        if (loading === false) {
            clearInterval(interval)
        }
        return () => clearInterval(interval)
    }, [loading, currentCustomer])

    useEffect(() => {
        localStorage.setItem("currentCustomer", currentCustomer)
        fetchEndpoints(customerObject[currentCustomer], setEndpoints, currentCustomer, lastSerialNumber, lastActivationDate)
    }, [currentCustomer]);

    useEffect(() => {
        setRowData(endpoints);
        setRowCount(endpoints.length);
    }, [endpoints]);

    const monthToComparableNumber = (date) => {
        if (date === undefined || date === null) {
            return null;
        }
        date = new Date(date)

        return date.getTime();
    };

    const dateComparator = (date1, date2) => {
        const date1Number = monthToComparableNumber(date1);
        const date2Number = monthToComparableNumber(date2);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    };

    const numberComparator = (num1, num2) => {
        if (num1 === null) {
            return -1;
        }
        if (num2 === null) {
            return 1;
        }
        return num1 - num2;
    }

    const tableSignalStrengthRenderer = (params) => {
        return (<span> {params.value==="N/A" || params.value == null ? "N/A" :(params.value === "Good" ? <IconAntennaBars5 className={classes.agTablerIconGreen}/> : <IconAntennaBars3 className={classes.agTablerIconRed}/>)} </span>)
    }

    function translateFormatter(params) {
        return t(params.value)
    }



    const columnSettings = [
        {
            field: "SerialNumber",
            headerName: t("Endpoint SN"),
            comparator: numberComparator,
            filter: false,
            flex:1
        },
        {
            field: "NetworkStatus",
            headerName: t("Signal Strength"),
            cellRenderer: tableSignalStrengthRenderer,
            filter: false,
            flex:1
        },
        {
            field: "EndpointStatus",
            headerName: t("Endpoint Status"),
            valueFormatter: translateFormatter,
            filter: false,
            flex:1
        },
        {
            field: "MeterStatus",
            headerName: t("Meter Status"),
            valueFormatter: translateFormatter,
            filter: false,
            flex:1
        },
        {
            field: "EncoderSerialNumber",
            headerName: t("Encoder SN"),
            filter: false,
            comparator: numberComparator,
            flex:1
        },
        {
            field: "FormattedActivationTime",
            headerName: t("Activation Time"),
            comparator: dateComparator,
            // sortable: false
            filter: false,
            flex:1
        },
        {
            field: "Customer",
            headerName: t("Customer Name"),
            filter: false,
            flex:1
        },{
            field: "Actions",
            headerName: t("Highlight"),
            cellRenderer: GridHighlightButton,
            sortable:false, //wait could we sort by the highlighted on top??
            filter: false,
            width: 150,
        }
    ]
    const [columnDefs, setColumnDefs] = useState(columnSettings);
    const [localeText,setLocaleText] = useState({
        noRowsToShow: t("noRowsToShow")
    });
    useEffect(() => {
        setColumnDefs(columnSettings);
        setLocaleText({noRowsToShow: t("noRowsToShow")})
        //don't need to change rowdata since translateFormatter should handle
    }, [t]);

    const [gridOptions, setGridOptions] = useState({
        columnDefs: [],
        domLayout: 'autoHeight',
        autoSizeStrategy: {
            type: 'fitGridWidth',
        }
    });

    const [destroyed, setDestroyed] = useState(false);

    useEffect(() => {
        setDestroyed(true);
        setTimeout(() => setDestroyed(false));
    }, [t]);

    const defaultColDef = useMemo(() => {
        return {
            sortable: true,
            resizable: true,
            filter: true,
            //flex: 1,
            minWidth: 100,
        };
    }, []);

    const [search, setSearch] = useState("")
    const loadMore = () => {
        fetch(`/api/v1/Activation/List?` + new URLSearchParams({customer_uuid:customerObject[currentCustomer], serial_number: lastSerialNumber, activation_date: lastActivationDate}),{
            method:"GET",
            credentials: 'include',
        }).then(response => response.json())
            .then(result => {
                if(!result){
                    setEndpoints([])
                    return
                }
                const withCustomerAndDateFields = result.Activations.map((e)=>({...e, Customer: currentCustomer, FormattedActivationTime: formatToBeaconDate(e.ActivationTime)}))
                setEndpoints((e)=> [...e, ...withCustomerAndDateFields])
                setLastActivationDate(result.activation_date)
                setLastSerialNumber(result.serial_number)
            }).catch((error)=>{
            console.log(error)
           // alert("Network Error, please try again!")
        })
    }

    const onCellClicked = (params) => {
        const { colDef, data } = params;

        if (colDef.field !== 'Actions') { //don't navigate away on the highlight button
            navigate(`/${params.data.SerialNumber}`)
        }
    }
    const dispatch = useDispatch()
    const [rowCount, setRowCount] = useState(0);
    const [openedError, { open: openError, close: closeError }] = useDisclosure(false);
    const highlightedList = useSelector(state => state.customer.highlightedList);
    const getRowStyle = (params) => {
        // Check if the current row's ID is in the highlighted rows
        if (highlightedList.includes(params.data.SerialNumber)) {
            return { backgroundColor: '#FDDBC0',
                fontWeight: 'bold',
                color: 'black'
            };
        }
        return null
    };
    const clear = () => {
        localStorage.setItem('highlightedList', JSON.stringify([]))
        dispatch(setHighlighted([]))
    }
    return (<div>
            <Modal
                opened={openedError}
                onClose={closeError}
                size="md"
                title={t("Activation Not Found")}
            >
                {t("sn-not-found", {n: search})}
            </Modal>

            {isMobile ? (
                <MobileResults
                    refreshPage={refreshPage}
                    logout={logout}
                    customers={customers}
                    isMultiCustomer={isMultiCustomer}
                    toggleRefresh={toggleRefresh}
                    loading={loading}
                    loadMore={loadMore}
                    lastActivationDate={lastActivationDate}
                    rowCount={rowCount}
                    endpoints={endpoints}
                    isLoading={isLoading}
                    navigate={navigate}
                    openError={openError}
                    search={search}
                    setSearch={setSearch}
                    formatToBeaconDate={formatToBeaconDate}
                />
            ) : (
                <div>
                    <div className={classes.positionSticky}>
                        <TopNavbar
                            loading={loading}
                            logout={logout}
                            openExportDrawer={openDrawer}
                            toggleRefresh={toggleRefresh}
                            refreshPage={refreshPage}
                        />
                    </div>

                    <Space h="xl"/>

                    <div className={['ag-theme-quartz', 'results-grid', styles.results].join(' ')}>
                        <Space h="sm"/>

                        <div>
                            <ExportDrawer
                                isMobile={false}
                                closeDrawer={closeDrawer}
                                isOpen={openedExportDrawer}
                            />

                            <div>
                                <Flex align="flex-start" direction="row" pt="18">
                                    <Card w="100%" bg="#FAFAFB" withBorder>
                                        <BreadcrumbsBar
                                            customers={customers}
                                            isMultiCustomer={isMultiCustomer}
                                        />
                                    </Card>
                                </Flex>

                                <div>
                                    <Card>
                                        <LoadingOverlay
                                            visible={isLoading}
                                            zIndex={10}
                                            overlayProps={{radius: 'sm', blur: 8}}
                                        />
                                        {destroyed ? null :(<AgGridReact
                                            rowData={rowData}
                                            columnDefs={columnDefs}
                                            defaultColDef={defaultColDef}
                                            onCellClicked={onCellClicked}
                                            gridOptions={gridOptions}
                                            localeText={localeText}
                                            getRowStyle={getRowStyle}
                                            // pagination={true} // Uncomment if want to enable pagination
                                            // paginationPageSize={25} // Set the number of rows per page
                                            // paginationPageSizeSelector={[10, 25, 50]}
                                        />)}
                                    </Card>
                                </div>

                                <Space h="sm"/>

                                <Flex justify="space-between" pl="xs" pr="xs">

                                    <Button color="red" disabled={highlightedList.length === 0} onClick={clear} leftSection={<IconBallpenOff/>}>
                                        <Text fw={500}>{t('Clear All Highlights')}</Text>
                                    </Button>
                                    <Flex direction="row" gap="sm">
                                        <Button className={classes.noClick} variant="light">
                                            <Text fw={500}>{t('displaying-results', { n: rowCount })}</Text>
                                        </Button>
                                        <Button disabled={!lastActivationDate} onClick={loadMore}>
                                            {t("Load More")}
                                        </Button>
                                    </Flex>
                                </Flex>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}